export default "__VITE_ASSET__D2_zH6hf__"